export const LANGUAGES = ['fi', 'en'] as const;

// TODO: Rename this just `Language`
/** NOTE: contentful language */
export type LanguageKey = (typeof LANGUAGES)[number];
export type MessageLanguage = Uppercase<LanguageKey>;

/** NOTE: contentful language */
export const DEFAULT_LANGUAGE: LanguageKey = 'fi';
